export class FormApiError extends Error {
  constructor(message, statusCode, errorMessages) {
    super(message);
    this.statusCode = statusCode;
    this.errorMessages = errorMessages;
  }
}
